module.exports = __webpack_public_path__ + "803d3c5d242e584250b3a508be8b583d.jpg";